/**
 * Tabela de medidas (ONC-178).
 *
 * O conteúdo já vem pronto do Liquid — jeans ou tecido plano, decidido pelo SKU —,
 * então aqui só cuidamos de abrir, fechar e devolver o foco.
 *
 * A escuta é delegada no documento porque o botão aparece em mais de um lugar da
 * página de produto e nem todos existem no carregamento.
 */
if (!window.MinimogSizeGuide) {
  window.MinimogSizeGuide = (() => {
    const SCROLL_LOCK = "m:overflow-hidden";
    let lastFocused = null;

    function open(el) {
      if (!el || !el.hasAttribute("hidden")) return;

      lastFocused = document.activeElement;
      el.removeAttribute("hidden");
      document.documentElement.classList.add(SCROLL_LOCK);
      document.body.classList.add(SCROLL_LOCK);

      const panel = el.querySelector(".m-size-guide__panel");
      if (panel) panel.focus();
    }

    function close(el) {
      if (!el) el = document.querySelector("[data-size-guide]:not([hidden])");
      if (!el || el.hasAttribute("hidden")) return;

      el.setAttribute("hidden", "");
      document.documentElement.classList.remove(SCROLL_LOCK);
      document.body.classList.remove(SCROLL_LOCK);

      if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
      lastFocused = null;
    }

    document.addEventListener("click", (event) => {
      const opener = event.target.closest("[data-size-guide-open]");
      if (opener) {
        event.preventDefault();
        open(document.querySelector("[data-size-guide]"));
        return;
      }

      const closer = event.target.closest("[data-size-guide-close]");
      if (closer) {
        event.preventDefault();
        close(closer.closest("[data-size-guide]"));
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") close();
    });

    return { open, close };
  })();
}
